<template>
  <div class="popup_box" data-id="calculate_checked" :class="{ active: value }">
    <div class="popup calculate">
      <span class="page_title">Данные расчетов</span>
      <span class="close_popup" @click="$emit('input', false)"></span>
      <div class="wrap flx">
        <div class="inp_wrap pick_up">
          <p>Дата от:</p>
          <input type="date" v-model="form.date_from">
        </div>
        <div class="inp_wrap give_away">
          <p>Дата до (включительно):</p>
          <input type="date" v-model="form.date_to">
        </div>
      </div>
        <div style="margin:14px 0">
          <div style="color: green; font-size: 18px">Оплаты: {{ results.payments_total | asPrice }}</div>
          <div style="color: orange; font-size: 18px">Приход: {{ results.income_total | asPrice }}</div>
          <div style="color: white; font-size: 18px">Итого: {{(parseFloat(results.payments_total) + parseFloat(results.income_total)) | asPrice}}</div>
          <div style="color: white; font-size: 18px">Товаров: {{results.product_count_total || 0}}</div>
        </div>
      <button class="btn" @click="sendGetTotals()">Отправить</button>
    </div>
  </div>
</template>

<script>

import { mapActions } from 'vuex'
import { prices } from '@/helpers/prices'

export default {
  name: 'SupplierCalculationModal',
  props: [
    'value', 'supplier_id'
  ],
  mixins: [prices],
  emits: ['input'],
  data () {
    return {
      form: {
        date_from: null,
        date_to: null
      },
      results: {
        payments_total: null,
        income_total: null,
        product_count_total: null
      }
    }
  },
  computed: {

  },
  methods: {
    ...mapActions('incoming', ['getTotals']),
    sendGetTotals () {
      const request = {
        supplier_id: this.supplier_id,
        ...this.form
      }
      this.getTotals(request).then(res => {
        this.results = res.data
      })
    }
  }
}
</script>

<style scoped>

</style>
